document.addEventListener("DOMContentLoaded", function () {

    const LIMIT = window.BYOB.limit;
const BUNDLE_PRICE = window.BYOB.bundlePrice;

let selectedProducts = [];

    const selectedCount = document.getElementById("byob-selected-count");
    const progressFill = document.getElementById("byob-progress-fill");
    const addBundleButton = document.getElementById("byob-add-bundle");

    function updateProgress() {

    if (selectedCount) {
        selectedCount.textContent = selectedProducts.length;
    }

    if (progressFill) {
        progressFill.style.width =
            (selectedProducts.length / LIMIT) * 100 + "%";
    }

    if (addBundleButton) {
        addBundleButton.disabled = selectedProducts.length !== LIMIT;
        addBundleButton.classList.toggle(
            "active",
            selectedProducts.length === LIMIT
        );
    }

    document.querySelectorAll(".byob-add-button").forEach(function (button) {

        if (
            selectedProducts.length >= LIMIT &&
            !button.classList.contains("selected")
        ) {
            button.disabled = true;
        } else {
            button.disabled = false;
        }

    });
const status = document.getElementById("byob-status");

if (status) {

    if (selectedProducts.length === LIMIT) {

        status.innerHTML = "✔ Ready to Checkout";

    } else {

        const remaining = LIMIT - selectedProducts.length;

        status.innerHTML =
            "Select " +
            remaining +
            " more product" +
            (remaining === 1 ? "" : "s");

    }

}
    updateFooter();

}


function updateFooter() {

    const slots = document.querySelectorAll(".byob-slot");

    // Reset all slots with numbers
    slots.forEach(function (slot, index) {

        slot.innerHTML = `
            <span class="byob-slot-number">${index + 1}</span>
        `;

    });

    // Insert selected products
    selectedProducts.forEach(function (product, index) {

        if (!slots[index]) return;

        slots[index].innerHTML = `
            <div class="byob-thumb-wrapper">

                <img
                    src="${product.image}"
                    alt="${product.title}"
                    class="byob-thumb">

                <button
                    class="byob-remove-thumb"
                    data-variant="${product.variantId}">
                    ×
                </button>

            </div>
        `;

    });

    const priceElement = document.getElementById("byob-total-price");

    if (priceElement) {

        priceElement.innerHTML =
            "₹" + Number(BUNDLE_PRICE).toLocaleString("en-IN");

    }

}

    document.addEventListener("click", function (event) {

        const button = event.target.closest(".byob-add-button");

        if (!button) return;

const product = {
    productId: button.dataset.productId,
    variantId: button.dataset.variantId,
    title: button.dataset.title,
    price: parseInt(button.dataset.price),
    image: button.dataset.image
};

if (!product.variantId) return;

        if (button.classList.contains("selected")) {

            button.classList.remove("selected");
            button.innerHTML = "Add To Box";

            selectedProducts = selectedProducts.filter(function (item) {
    return item.variantId !== product.variantId;
});
        } else {

            if (selectedProducts.length >= LIMIT) return;

            button.classList.add("selected");
            button.innerHTML = "Added";

            selectedProducts.push(product);

        }

        updateProgress();

    });
    document.addEventListener("click", function (event) {

    const removeButton = event.target.closest(".byob-remove-thumb");

    if (!removeButton) return;

    const variantId = removeButton.dataset.variant;

    // Remove from selected array
    selectedProducts = selectedProducts.filter(function (product) {
        return product.variantId !== variantId;
    });

    // Reset original product button
    const productButton = document.querySelector(
        '.byob-add-button[data-variant-id="' + variantId + '"]'
    );

    if (productButton) {
        productButton.classList.remove("selected");
        productButton.innerHTML = "Add To Box";
    }

    updateProgress();

});

    updateProgress();


/* ===========================
   ADD BUNDLE TO CART
=========================== */

addBundleButton.addEventListener("click", async function () {

    if (selectedProducts.length !== LIMIT) {
        return;
    }

    addBundleButton.disabled = true;

    const items = selectedProducts.map(function(product) {
        return {
            id: product.variantId,
            quantity: 1
        };
    });

    try {

        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                items: items
            })
        });

        if (!response.ok) {
            throw new Error("Unable to add bundle.");
        }

        console.log("Bundle added successfully");

// Wait for Shopify cart to update
setTimeout(function () {

    const cartButton = document.querySelector('a[href="/cart"]');

    if (cartButton) {
        cartButton.click();
    }

}, 500);

        

    } catch (error) {

        console.error(error);
        alert("Something went wrong while adding your bundle.");

    } finally {

        addBundleButton.disabled = false;

    }

});

});